import { useState, useEffect, useCallback } from 'react';

interface SliderImage {
  url: string;
  title: string;
  description: string;
}

const sliderImages: SliderImage[] = [
  {
    url: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?w=1920&h=607&fit=crop",
    title: "Judiciary Modernization Program",
    description: "The Tanzania Judiciary launches a comprehensive modernization program to enhance access to justice through digital transformation."
  },
  {
    url: "https://images.unsplash.com/photo-1453945619913-79ec89a82c51?w=1920&h=607&fit=crop",
    title: "New E-Filing System Launch",
    description: "The High Court introduces a state-of-the-art electronic filing system to streamline court processes and improve efficiency."
  },
  {
    url: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=1920&h=607&fit=crop",
    title: "Chief Justice's Annual Address",
    description: "Chief Justice delivers keynote speech highlighting achievements and outlining future plans for the judiciary system."
  },
  {
    url: "https://images.unsplash.com/photo-1479142506502-19b3a3b7ff33?w=1920&h=607&fit=crop",
    title: "Judicial Training Program",
    description: "Comprehensive training initiative launched for judicial officers focusing on emerging legal technologies and best practices."
  }
];

export const useSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(sliderImages.length - 1);
  const [isAnimating, setIsAnimating] = useState(false);

  const nextSlide = useCallback(() => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setPreviousIndex(currentIndex);
    setCurrentIndex((prevIndex) => 
      prevIndex === sliderImages.length - 1 ? 0 : prevIndex + 1
    );
    
    setTimeout(() => setIsAnimating(false), 700);
  }, [currentIndex, isAnimating]);

  const previousSlide = useCallback(() => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setPreviousIndex(currentIndex);
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? sliderImages.length - 1 : prevIndex - 1
    );
    
    setTimeout(() => setIsAnimating(false), 700);
  }, [currentIndex, isAnimating]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return {
    currentImage: sliderImages[currentIndex],
    previousImage: sliderImages[previousIndex],
    nextSlide,
    previousSlide,
    totalSlides: sliderImages.length,
    currentIndex,
    isAnimating
  };
};